import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  container: {
    width: '100%',
    minHeight: '600px',
    height: '100%'
  }
})
